import useSEO from "../lib/useSEO";

export default function Privacy() {
  useSEO({
    title: "Datenschutz | Tæste GbR — Catering & Streetfood",
    description: "Datenschutzerklärung der Tæste GbR – Catering & Streetfood aus Lohsa. Informationen zur Verarbeitung personenbezogener Daten.",
    path: "/datenschutz",
  });
  return (
    <div data-testid="privacy-page" className="max-w-3xl mx-auto px-6 lg:px-12 py-20 md:py-28">
      <p className="eyebrow">Rechtliches</p>
      <h1 className="font-display text-5xl md:text-6xl mt-3 leading-[1.05]">Datenschutzerklärung</h1>

      <div className="mt-10 space-y-10 leading-relaxed">
        <section>
          <h2 className="font-display text-2xl">1. Datenschutz auf einen Blick</h2>
          <p className="mt-3 text-[hsl(var(--muted-foreground))]">
            Der Schutz Ihrer persönlichen Daten ist uns ein wichtiges Anliegen. Nachfolgend informieren
            wir Sie darüber, welche personenbezogenen Daten beim Besuch unserer Website erhoben und
            verarbeitet werden.
          </p>
        </section>

        <section>
          <h2 className="font-display text-2xl">2. Verantwortlicher</h2>
          <p className="mt-3">Tæste GbR – Catering & Streetfood</p>
          <p className="text-[hsl(var(--muted-foreground))]">Vertreten durch:</p>
          <p>Edgar Robel und Annabell Möller</p>
          <p className="mt-3">
            Alte Bahnhofstraße 1a<br />
            02999 Lohsa<br />
            Deutschland
          </p>
          <p className="mt-3">
            E-Mail:{" "}
            <a href="mailto:info@taeste.de" className="underline hover:text-[hsl(var(--primary))]">
              info@taeste.de
            </a>
          </p>
          <p>
            Telefon:{" "}
            <a href="tel:+4915129402613" className="underline hover:text-[hsl(var(--primary))]">
              +49 1512 9402613
            </a>
          </p>
        </section>

        <section>
          <h2 className="font-display text-2xl">3. Erhebung und Speicherung personenbezogener Daten</h2>
          <p className="mt-3 text-[hsl(var(--muted-foreground))]">
            Beim Besuch unserer Website werden durch den Hosting-Anbieter automatisch Informationen
            erfasst. Dazu gehören insbesondere:
          </p>
          <ul className="mt-4 space-y-1.5 text-[hsl(var(--muted-foreground))]">
            <li className="flex items-start gap-2"><span className="text-[hsl(var(--primary))]">·</span> IP-Adresse</li>
            <li className="flex items-start gap-2"><span className="text-[hsl(var(--primary))]">·</span> Datum und Uhrzeit des Zugriffs</li>
            <li className="flex items-start gap-2"><span className="text-[hsl(var(--primary))]">·</span> Browsertyp und Browserversion</li>
            <li className="flex items-start gap-2"><span className="text-[hsl(var(--primary))]">·</span> Betriebssystem</li>
            <li className="flex items-start gap-2"><span className="text-[hsl(var(--primary))]">·</span> Referrer-URL</li>
            <li className="flex items-start gap-2"><span className="text-[hsl(var(--primary))]">·</span> Name der abgerufenen Datei</li>
          </ul>
          <p className="mt-4 text-[hsl(var(--muted-foreground))]">
            Diese Daten dienen der technischen Bereitstellung und Sicherheit der Website.
          </p>
        </section>

        <section>
          <h2 className="font-display text-2xl">4. Kontaktaufnahme</h2>
          <p className="mt-3 text-[hsl(var(--muted-foreground))]">
            Wenn Sie uns per Kontaktformular oder E-Mail kontaktieren, werden die von Ihnen
            angegebenen Daten ausschließlich zur Bearbeitung Ihrer Anfrage verwendet.
          </p>
        </section>

        <section>
          <h2 className="font-display text-2xl">5. Speicherung der Daten</h2>
          <p className="mt-3 text-[hsl(var(--muted-foreground))]">
            Ihre personenbezogenen Daten werden nur so lange gespeichert, wie dies zur Bearbeitung
            Ihrer Anfrage erforderlich ist oder gesetzliche Aufbewahrungspflichten bestehen.
          </p>
        </section>

        <section>
          <h2 className="font-display text-2xl">6. Ihre Rechte</h2>
          <p className="mt-3 text-[hsl(var(--muted-foreground))]">Sie haben jederzeit das Recht auf:</p>
          <ul className="mt-4 space-y-1.5 text-[hsl(var(--muted-foreground))]">
            <li className="flex items-start gap-2"><span className="text-[hsl(var(--primary))]">·</span> Auskunft über Ihre gespeicherten Daten</li>
            <li className="flex items-start gap-2"><span className="text-[hsl(var(--primary))]">·</span> Berichtigung unrichtiger Daten</li>
            <li className="flex items-start gap-2"><span className="text-[hsl(var(--primary))]">·</span> Löschung Ihrer Daten</li>
            <li className="flex items-start gap-2"><span className="text-[hsl(var(--primary))]">·</span> Einschränkung der Verarbeitung</li>
            <li className="flex items-start gap-2"><span className="text-[hsl(var(--primary))]">·</span> Datenübertragbarkeit</li>
            <li className="flex items-start gap-2"><span className="text-[hsl(var(--primary))]">·</span> Widerspruch gegen die Verarbeitung</li>
          </ul>
          <p className="mt-4 text-[hsl(var(--muted-foreground))]">
            Außerdem haben Sie das Recht, sich bei einer Datenschutzaufsichtsbehörde zu beschweren.
          </p>
        </section>

        <section>
          <h2 className="font-display text-2xl">7. SSL- bzw. TLS-Verschlüsselung</h2>
          <p className="mt-3 text-[hsl(var(--muted-foreground))]">
            Diese Website nutzt aus Sicherheitsgründen eine SSL- bzw. TLS-Verschlüsselung, um die
            Übertragung vertraulicher Inhalte zu schützen.
          </p>
        </section>

        <section>
          <h2 className="font-display text-2xl">8. Externe Links und soziale Netzwerke</h2>
          <p className="mt-3 text-[hsl(var(--muted-foreground))]">
            Unsere Website kann Links zu externen Websites und sozialen Netzwerken enthalten. Für die
            Inhalte und Datenschutzpraktiken dieser Anbieter übernehmen wir keine Verantwortung.
          </p>
        </section>

        <section>
          <h2 className="font-display text-2xl">9. Änderungen dieser Datenschutzerklärung</h2>
          <p className="mt-3 text-[hsl(var(--muted-foreground))]">
            Wir behalten uns vor, diese Datenschutzerklärung bei Bedarf anzupassen, damit sie stets
            den aktuellen rechtlichen Anforderungen entspricht.
          </p>
        </section>
      </div>
    </div>
  );
}
